import React from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { Icon, Label } from "semantic-ui-react";

import "./SortableCard.css";

import { BasicTrackCard } from "./BasicTrackCard";

import { viewingReorder } from "./atoms";
import { futureOrder, futureOrderChanged } from "./sort_atoms";

export function SortableCard({ track, color }) {
  const showIndex = useRecoilValue(viewingReorder);
  const startedChanging = useRecoilValue(futureOrderChanged);

  const [data, setFutureOrder] = useRecoilState(futureOrder(track.url));

  if (!showIndex) return <BasicTrackCard track={track} color={color} />;

  const { changed, index, futureIndex } = data;

  const url = track.url;

  return (
    <BasicTrackCard track={track} color={color} disabled>
      <Label
        color={startedChanging ? "green" : "blue"}
        className="track-index"
        onClick={() => setFutureOrder(url)}
      >
        {index + 1}
      </Label>
      {startedChanging ? (
        <Label color={changed ? "olive" : "gray"} className="track-next-index">
          <Icon name="long arrow alternate right" />
          {futureIndex + 1}
        </Label>
      ) : null}
    </BasicTrackCard>
  );
}
